import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceES() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Volver a la aplicación
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Términos de Servicio</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Última actualización: {new Date().toLocaleDateString('es-ES')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Información de la Empresa</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers es operado por <span className="font-semibold">Puretech s.r.o.</span>,
                  una <span className="font-semibold">sociedad de responsabilidad limitada</span> constituida bajo las leyes de <span className="font-semibold">Chequia</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Detalles de la Empresa:</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Número de Identificación (IČO):</strong> 05503795</li>
                    <li><strong>Estado del IVA:</strong> No contribuyente</li>
                    <li><strong>Dirección de la Oficina:</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, Chequia</li>
                    <li><strong>Correo Electrónico:</strong> support@simplestickers.app</li>
                    <li><strong>Sitio Web:</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                    <li><strong>Representada por:</strong> Pavel Vlček</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Aceptación de los Términos</h2>
              <p className="leading-relaxed">
                Al acceder y utilizar Simple Stickers ("el Servicio"), acepta y acepta estar sujeto a los términos y disposiciones de este acuerdo. Si no está de acuerdo con lo anterior, por favor no utilice este servicio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Descripción del Servicio</h2>
              <p className="leading-relaxed">
                Simple Stickers es una aplicación de gestión de tareas y proyectos que proporciona a los usuarios herramientas para organizar notas adhesivas utilizando un sistema de tablero estilo Kanban. El servicio incluye niveles gratuitos y premium con diferentes conjuntos de funciones y límites de uso.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Cuentas de Usuario</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Usted es responsable de mantener la confidencialidad de su cuenta y contraseña y de restringir el acceso a su computadora. Acepta asumir la responsabilidad de todas las actividades que ocurran bajo su cuenta o contraseña.
                </p>
                <p className="leading-relaxed">
                  Debe proporcionar información precisa y completa al crear su cuenta y mantener esta información actualizada.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Suscripción y Términos de Pago</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Nivel Gratuito:</strong> Incluye acceso a funciones básicas con limitaciones en el número de notas adhesivas (50) y sugerencias de IA (10 por día).
                </p>
                <p className="leading-relaxed">
                  <strong>Nivel Premium:</strong> Disponible por $48 por año, incluye límites aumentados (1000 notas adhesivas, 100 sugerencias de IA por día) y funciones adicionales como capacidades para compartir notas adhesivas.
                </p>
                <p className="leading-relaxed">
                  El procesamiento de pagos es manejado por Polar. Las suscripciones se renuevan automáticamente a menos que se cancelen. Puede cancelar su suscripción en cualquier momento a través de la configuración de su cuenta.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Uso Aceptable</h2>
              <p className="leading-relaxed">
                Acepta no utilizar el servicio para almacenar, transmitir o distribuir contenido que sea ilegal, dañino, amenazante, abusivo, acosador, difamatorio, vulgar, obsceno o de otro modo objetable. También acepta no interferir con el servicio o intentar acceder a cuentas pertenecientes a otros.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Privacidad y Protección de Datos Personales</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Su privacidad es importante para nosotros. Para obtener detalles sobre cómo recopilamos, usamos y protegemos su información personal, consulte nuestra <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Política de Privacidad</a>.
                </p>
                <p className="leading-relaxed">
                  Al utilizar este servicio, también acepta nuestra Política de Privacidad y el procesamiento de sus datos personales de acuerdo con el RGPD y las leyes de protección de datos aplicables.
                </p>
                <p className="leading-relaxed">
                  Para ejercer sus derechos bajo el RGPD o para consultas sobre protección de datos, contáctenos en <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Disponibilidad del Servicio y Soporte</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Disponibilidad del Servicio:</strong> Nos esforzamos por la máxima disponibilidad del servicio y operación confiable. En caso de interrupciones no planificadas, trabajamos para resolverlas rápidamente. El servicio se proporciona "tal cual" sin garantías formales de disponibilidad.
                </p>
                <p className="leading-relaxed">
                  <strong>Mantenimiento:</strong> Para garantizar la seguridad y estabilidad, podemos realizar mantenimiento continuo del servicio. Intentamos programar el mantenimiento planificado durante períodos de bajo uso y proporcionar aviso previo siempre que sea posible. En casos urgentes (por ejemplo, parches de seguridad), el mantenimiento puede ocurrir sin previo aviso.
                </p>
                <p className="leading-relaxed">
                  <strong>Soporte:</strong> Ofrecemos soporte técnico por correo electrónico en support@simplestickers.app. Nos esforzamos por responder lo más rápido posible, sin embargo, no se garantizan tiempos de respuesta específicos.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Política de Reembolso</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Garantía de Devolución de Dinero de 30 Días:</strong> Si no está satisfecho con el servicio premium, puede solicitar un reembolso completo dentro de los 30 días posteriores a su compra inicial. Después de 30 días, todos los pagos son finales y no reembolsables.
                </p>
                <p className="leading-relaxed">
                  <strong>Errores de Facturación:</strong> Si cree que se le ha cobrado incorrectamente, contáctenos en support@simplestickers.app dentro de los 30 días posteriores al cargo.
                </p>
                <p className="leading-relaxed">
                  <strong>Procesamiento de Reembolsos:</strong> Los reembolsos aprobados se procesarán dentro de 10-14 días hábiles al método de pago original. Nos reservamos el derecho de aprobar o denegar solicitudes de reembolso a nuestra entera discreción.
                </p>
                <p className="text-sm text-gray-600">
                  Nota: Las cancelaciones de suscripción no resultan automáticamente en reembolsos. Debe solicitar explícitamente un reembolso dentro del período de 30 días.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Restricciones de Edad y Elegibilidad</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Edad Mínima:</strong> Debe tener al menos 16 años para usar este servicio.
                </p>
                <p className="leading-relaxed">
                  <strong>Consentimiento Parental:</strong> Los usuarios menores de 18 años deben tener el consentimiento de los padres o tutores para usar el servicio.
                </p>
                <p className="leading-relaxed">
                  <strong>Usuarios Empresariales:</strong> Las cuentas empresariales requieren que el usuario tenga autoridad para vincular a la organización.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Ley Aplicable y Jurisdicción</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Estos Términos se regirán e interpretarán de acuerdo con las leyes de la República Checa, sin tener en cuenta sus disposiciones sobre conflictos de leyes.
                </p>
                <p className="leading-relaxed">
                  Cualquier disputa que surja de estos Términos o su uso del Servicio estará sujeta a la jurisdicción exclusiva de los tribunales de la República Checa.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Moderación de Contenido</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nos reservamos el derecho de eliminar, modificar o negarnos a mostrar cualquier contenido que viole estos Términos o que consideremos inapropiado, a nuestra entera discreción.
                </p>
                <p className="leading-relaxed">
                  Si cree que el contenido debe ser revisado, contáctenos en support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Propiedad Intelectual</h2>
              <p className="leading-relaxed">
                El servicio y su contenido original, características y funcionalidad son propiedad de Simple Stickers y están protegidos por derechos de autor internacionales, marcas registradas, patentes, secretos comerciales y otras leyes de propiedad intelectual.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Limitación de Responsabilidad</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  En la máxima medida permitida por la ley aplicable, Simple Stickers no será responsable de ningún daño indirecto, incidental, especial, consecuente o punitivo, incluidos, entre otros, la pérdida de ganancias, datos, uso, buena voluntad u otras pérdidas intangibles, que resulten de su uso del servicio.
                </p>
                <p className="leading-relaxed">
                  Esta limitación de responsabilidad no se aplica a los daños causados por mala conducta intencional o negligencia grave, o según lo prohibido por la ley aplicable.
                </p>
                <p className="leading-relaxed">
                  Nuestra responsabilidad total hacia usted por cualquier reclamo que surja de su uso del servicio no excederá la cantidad que nos pagó en los 12 meses anteriores al reclamo, o €100, lo que sea mayor.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Terminación</h2>
              <p className="leading-relaxed">
                Podemos terminar o suspender su cuenta y prohibir el acceso al servicio de inmediato, sin previo aviso o responsabilidad, bajo nuestra exclusiva discreción, por cualquier motivo, incluido, entre otros, si incumple los Términos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Cambios en los Términos</h2>
              <p className="leading-relaxed">
                Nos reservamos el derecho de modificar o reemplazar estos Términos en cualquier momento. Si una revisión es material, proporcionaremos al menos 30 días de aviso antes de que entren en vigencia los nuevos términos.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Información de Contacto</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Si tiene alguna pregunta sobre estos Términos de Servicio, contáctenos:
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>Correo Electrónico:</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Para todas las consultas sobre soporte, asuntos legales, privacidad, protección de datos y preguntas comerciales
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
